export default __webpack_public_path__ + "static/media/up-arrow.26fc6e24.svg";